import { render, staticRenderFns } from "./DShareComplianceWireExport.vue?vue&type=template&id=3e72a3ba&scoped=true&"
import script from "./DShareComplianceWireExport.vue?vue&type=script&lang=js&"
export * from "./DShareComplianceWireExport.vue?vue&type=script&lang=js&"
import style0 from "./DShareComplianceWireExport.vue?vue&type=style&index=0&id=3e72a3ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72a3ba",
  null
  
)

export default component.exports